var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g3, _path11, _g4, _path12, _g5, _path13, _g6, _g7, _path14, _path15, _path16, _path17, _path18, _g8, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagForSouthGeorgiaAndSouthSandwichIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26137",
    gradientUnits: "userSpaceOnUse",
    x1: -1760.792,
    x2: -1759.792,
    gradientTransform: "matrix(-.5968 -1.5125 -1.2072 .7477 87.385 -3301.715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2a5f9e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2v30H2c0 16.6 13.4 30 30 30s30-13.4 30-30S48.6 2 32 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12h21v21H12z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9 8.1V14h-7.3L26 32h6v-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18.9H5c-1.9 4-3 8.4-3 13.1h12V13.9h-3v5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ed4c5c",
    d: "M32 27.1L19 11h-6l17 21h2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 5v6H11v3h21V2c-4.7 0-9.1 1.1-13.1 3z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 5H18.9c-6 2.9-11 7.9-13.9 13.9V32h6V11h21V5z",
    fill: "#ed4c5c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6 41.7c-.6.6-1.8 1.2-2.6.6c-1.1.2-.5.5-1.5-.2c-.7.2-.9.2-1.9-.2c-.5.9-1.1 1.1-1.9.5c.1-.2.3-.4.4-.6c0 .4-1.6.3-1.7.3c.9-2.9 4.6-5.3 6.7-7.3c1 1.8 3.7 4.7 2.5 6.9",
    fill: "#6a4c2d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M48.8 42h1.5l-.7-.3l5.9-.3l-.8-.3l-.8-1l-3.6-.3l-.3-.5l-1.9-.2l-1.1.8l.8 2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8 31.1c.1-.1.5-.2.4-.7c0-.5-.5-.6-.8-.6c-.3 0-.5.2-.5.2l-.9-.5s.4-2.7.9-2.9c.4-.3.5-.5.5-.5l-.2-.3l-2.8-.3l-2.7.3s-.2.3-.2.4c0 .1 0 .3.5.6c.5.4.9 2.7.9 2.7l-.8.3s-.3-.1-.4-.1s-.5.2-.5.7c0 .5.4.8.4.8s2.6-.3 2.9.4c.5-.6 3-.3 3.3-.5",
    fill: "#656263"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 28.3c.2-.6.6-.6 1.2-.6c1.2 0 1.1.4 1.5 1.4c.5 1.4 1.4 2.8 1.5 4.4c.1 1.7.1 4-.7 5.5c-.6 1.1.7 1.4 1.5 1.8l-.6-.2l.6.5l-.7-.3l.4.4l-1-.5l.4.4l-.8-.4c.1.2.3.3.4.5c-.2-.1-.4-.2-.7-.3v.2c-.8-.6-2-.7-2.3-1.6c-.4-1-1.2-2.5-1.1-3.6c.3-2.3 1-5.3.4-7.6",
    fill: "#3e4347"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00713d",
    d: "M44 39.7l-.3 1l.4-.5v1l.3-.5v1.2l.3-.6v1.1l.3-.5l.2 1l.3-.7l.4.8l.1-.6l.6.7v-.7l.7.6v-.4l.7.3v-.4l.8.2l-.5-.5h.5l-.8-.5h.4l-.7-.6h.5l-.8-.6l.4-.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9 31.4h2.2s1.4 0 1.6.5c.3-.6 1.5-.6 1.5-.6c.7 0 1.5-.1 2.2-.1v5.4c-.4 2.1-2 3.6-3.6 4.2c-2-.6-3.3-2.3-3.7-4.2c0-1.8-.1-3.5-.2-5.2",
    fill: "#ffffff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7 31.4l3.1 8.4l2.8-8.6c-.9.1-2.8-.1-3 .7c-.3-.8-2.3-.5-2.9-.5",
    fill: "#006b00"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#cdad56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 17.8l1.8-1.5l.3-1.1l-.4.2l-.1-.5l-.1-.1l-.1.2l-.2-.4l-.3.4l.5 1l-.5.8l-.2-.5l.2-.6l-.3.1v-.6l-.4.4l-.1-.1l.4 1.2l-.3.4l-.5-1.3l-.1.3l-.2-.2l.1.7h-.2l.3.4l-.3.4l.6-.2l-.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6 17.8L41 16.4l-.1-1l.2.2l.2-.5l.2.3l.3-.4l.2.3l-.6.9l.4.7l.2-.5l-.3-.4h.4v-.5l.3.3l.2-.3l-.5 1.3l.2.3l.4-1l.2.2l.2-.2l-.1.6h.2l-.1.4l.1.3l-.5-.2l.1.4z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2 32.6l-.3-.4l.4-.5l-.6.1l-.1-.6l-.3.8l-.6-.3l.4.5l-1.1.8l.3.1l-.4.1l.1.2l-.3.1l.2.1h-.8V33h.8l-.4-.8l-.3.2l-.2-.3l-.7.2l.4-.5l-.6.3l-.1-.7l-.1.6l-.6-.1l.5.4l-.4.5l.5-.2l.2.6l.1-.4l.3.2h.1l.1 2l-.2.4l.1-.1l.3.7l.1-.6l.5-.2l.3-.1l.2.1l.1.6l-.5.7H45l-.2.3l.6-.3v.3l.3-.3v.2l.2-.1l-.5 1.4l.5-.4v.6l.2-.4l.2-.2l.1.2v-.5l.2.1l-.2-.7l.3.2l-.2-.9l.8-.4v-.4H47l.2-.4l.1-.6v.3v-.5l.3.1l-.2-.3l.4-.2h-.2l.5-.5l-1.3.9l-.1 1.7l-.4-1.9l.2.3l.2-.8l.4.1l-.2-.3l.2.1l-.3-.2l.4-.1l-.4-.3l.5-.2v.6l.2-.6l.7.2M45 34.8l.1-.7l.8-.1l-.9.8",
    fill: "#ffc900"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ed4c5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8 48.8c.3-.1 2 .4 2.7 1.1c-.1-1.3-.5-2.2-.5-2.2s-1-.3-1.2-.2c-.2.2-.8.9-1 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2 43c-.1 0-.2.1-.4.3c-.1.3-.2 1.2-.4 1.4s-.4.2-.4.4s0 .6.6.8c.5 0 1.4-.9 1.4-.9s.4-.5.6-1c-1 .3-1.7-.6-1.4-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4 48.6c-.3-.1-2.1.4-2.7 1.1c.1-1.3.5-2.2.5-2.2c.1 0 1-.3 1.1-.2c.2.2.8.9 1.1 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8 42.8c.1 0 .2.2.3.4c.1.3.3.8.5 1c.2.2.4.5.4.7s0 .4-.6.6c-.5 0-1.3-.7-1.3-.7s-.4-.5-.6-1c1 .4 1.7-.6 1.3-1"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3 45.4c.4-.4.7-.6.7-.6s-.5-.6-.6-1c1 .5 2.3-1.1.8-1.2c-1 .1-1.9.9-2.5 1.9c-3.1-1.5-6.7-1.4-9.6.1c-.6-1-1.4-1.8-2.4-1.8c-1.5.1-.1 1.7.8 1.2c-.1.4-.6 1-.6 1s.3.1.7.5c-.8.6-1.5 1.3-2.1 2.2c0 0 1.1.7 1.1 1.1c.5-.7 1.1-1.4 1.9-1.9c.4.7.7 1.7.9 3.1c0 0 .6-1.6.9-1.6c.2 0 0-1.1-.5-2.2c2.4-1.2 5.5-1.4 8.1-.2c-.5 1.1-.6 2.1-.5 2.4c.3 0 1 1.4 1 1.4c.2-1.3.5-2.3.9-3c.7.5 1.3 1.1 1.9 1.8c.6-.7 1.1-1 1.1-1c-.5-.9-1.2-1.6-2-2.2",
    fill: "#ffce31"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#1e5aa6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7 31.2h.4l-.8 1l.9 1.1l-1.8 2.3l1.7 2c-.2.5-.4.9-.7 1.2l-1-1.1l1.8-2.2l-1.4-1.6l.9-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6 31.4h-.5l.8.9l-.9 1.1l1.9 2l-1.5 2.1c.2.5.5 1 .7 1.3l.9-1.2l-1.9-2.1l1.4-1.8l-.9-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7 36.8l-.7.9l2.4 2.8c.4-.2.8-.5 1.1-.7l-1.2-1.4l.5-1.5l.7.8l-2.3 2.9c-.4-.2-.8-.4-1.2-.7l1.2-1.5l-.5-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 35.5l.4.5l-.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1 35.9l.4-.4l-.2-.2z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 29.5c.2 0 1.4 0 1.4.2c-.5.2-.8.5-1.1 1c.3.5.6.9.9 1.4c.1 1-1.3 2-1.2 3.5c.1 1.1.1 2.2 1 2.9c1.1 1 .6-2.1.7-2.4c0-.2 1.1 1 1.1 1.4c-.1 1.1-.5.5-.5.8c-.3 1.1-.3 1.8-1.3 1.8c-1.4-.8-2.7-8.8-1-10.6",
    fill: "#f5f5f5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4 27.6s1.1 1.2 1.9 1.2c.1.4-.3.7-.5.8c-.4-.1-.7 0-1.6-1c.1-.6.3-.9.2-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 24.8c.1-.5.4-.8.7-.8c-.1-.3.5-1.9 2.3-2.4c.1.8-.7 1.5-.7 1.5s2.6-.4 3.1-1.1c-.1.3-.6 2.1-3.3 2.1c1 1-.3 1.8-.9 1.5c.9-.8-.5-1.3-1.2-.8"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#00f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8 29.7s1.4.4 1.6-1.6c-.3-.9-.7-2.8-.1-3.3c-.6-.4-1.2 0-1.2 0c0 .1-.6.8.1 2.2c-1.7-.4-1 1.2-1 1.2c.1-.2 1-.5 1.2.8c0 .2-.7.7-.6.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3 28.1s1.5-.8 1.4-2.7c-1.3 0-1.7 1.7-1.7 1.7l.3 1"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7 28s-1.1 1-1.7.6c-.5.3-1-.2-1-.2s.6 2.3 2.9.6l-.2-1",
    fill: "#ffffff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42 28.6c.1-.5.5-.7.8-.3c.4.1.8-1.6-.6-1.3c.4-2.2-.8-3-.8-3s-.4 2.4-.2 2.9s-.3-.8-1.9-1.2c0 1.8 1.8 2.7 1.8 2.7s.4.4.9.2",
    fill: "#00f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1 24.9s-1 0-.4 1.1c-.5.1-1.5-.5-.8-1.4c-2.3-.1-3.3-1.2-3.3-2.2c.7.7 2.3.4 2.9.9c-.7-.7-.6-1.6-.6-1.6s2 .6 2.4 2.4c-.1.2-.2.8-.2.8",
    fill: "#ffffff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9 24.3c-.1.2-.1.4-.2.5c1.9 0 3.7.1 5.6.1c-.1-.6-.5-1.2-.7-1.7c.1-.4.1-1.1.2-1.6s-.7-.6-.5-1.1c-.1.2.6 0 .6 0c-.3 0-.4-1-.7-1.1c-.7-.2-1 0-1.6 0c-.8 0-2 0-1.8-1.2c.4.1.9 0 1-.4c-.1-.1-1.4-.3-1.6-.3c-.2 0-1.6.4-1.7.5c.4.5.8.4 1.2.8c.2.2.3 1.1.1 1h.2c-.1.1-.2.2-.2.3h.4c-.1.2-.2.3-.3.5h.5c-.1.2-.1.3-.2.5c.1 0 .2-.1.4-.1c.4.9-.3 2.4-.7 3.3m4.2-1c.2-.1.2-.1 0 0m-.2-1.9c.8 0 .4 1.8.1 1.9c-.8.1-.7-1.9-.1-1.9m-2 .6c-.3-1.6 2-1.1 1.3.1c-.1.2-.6 1.3-.6 1.3c-.6 0-.8-.9-.7-1.4m-1 1c.4-.5-.3-1.7.6-2c0 .7 0 1.7-.4 2.4c-.1-.2-.2-.3-.4-.2c.1 0 .2-.1.2-.2",
    fill: "#923f00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7 26.4l2.8 1.8l2.5-1.7s.5-.3.5-.5s-.2-.1-.3-.1l-2.6 1.8l-2.7-1.7s-.2-.1-.2.1c-.1.2 0 .3 0 .3",
    fill: "#b4b6b9"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff7000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 39.8l-1 .1l.3.3h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6 28.4l-1.3.7l.3.3h1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3 40.4l.6.4l1.7-.3l-.5-.3z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51 31.7c-.2-.1-.8-.2-1.6.3v1.7s1.1-.6 1.7-.5c0-.4 0-1.1-.1-1.5",
    fill: "url(#IconifyId17ecdb2904d178eab26137)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30c-.3.8.7 2 1 2.7c.7-.8 1-.9 1 .2c0 .3.1.7 0 1c-.1.3-.8.1-.5.5c.6 1 .5 1.6.2 2.6c-.1.4-.5 2.5-1.1 2.6c0 0 .1-1.5 0-1.7c-.1-.3-.6-1-.4-1.3c-.2.3-1 1.5-1.5 1.1c.2.5 0 .7-.1 1.2c-.1.3-.1.7-.1 1c-.1.4-.7.8-.6 1.4c-2.1-.7-3.5-2.3-2.8-4.6c.2-.5.4-1 .9-1.3c.5-.4.6-1 .8-1.7c.1-.2.3-.5.3-.8c-.1-.6.3-.8.3-1.2c.1-.7.2-1.5.2-2.2c0-1.1.4-1 1.3-1.5c.3-.1 1.5.1 1.8.3c.2.3-.5 1.5-.7 1.7",
    fill: "#8a9396"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M42.6 24.7h5.9v1.2h-5.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagForSouthGeorgiaAndSouthSandwichIslands);
export default __webpack_public_path__ + "static/media/flag-for-south-georgia-and-south-sandwich-islands.ebba8f36bcabfb0668c0a3d2d1d4e08e.svg";
export { ForwardRef as ReactComponent };